import API from '../api/api';
import { ApiRoutes } from '../constans/api';
import { clearUserData, updateUserTokens } from '../redux/slices/auth.slice';
import store from '../redux/store';

export interface ILoginRequest {
  email: string;
  password: string;
}

export const loginRequest = async (credentials: ILoginRequest) => {
  const { login } = ApiRoutes;
  const { data } = await API.post(login, credentials);
  return data;
};

export const microsoftLogin = async (accessToken: string) => {
  const { microsoft } = ApiRoutes;
  const { data } = await API.post(microsoft, { access_token: accessToken });

  return data;
};

export const getMicrosoftLoginUrl = async (redirectUri?: string, nonce?: string) => {
  const params = new URLSearchParams();
  if (redirectUri) params.append('redirect_uri', redirectUri);
  if (nonce) params.append('nonce', nonce);

  const { microsoftUrl } = ApiRoutes;
  const { data } = await API.get(`${microsoftUrl}?${params.toString()}`);
  return data.login_url;
};

export interface IRefreshTokenRequest {
  refresh: string;
}

export const refreshTokenRequest = async (refresh: IRefreshTokenRequest) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const { refreshToken } = ApiRoutes;
    const { data } = await API.post(refreshToken, refresh);
    return data;
  } catch (e) {
    throw e;
  }
};

//Cant add to hook, axios api dont cooperate with hooks
export const refreshToken = async () => {
  const { dispatch } = store;
  try {
    const { userData } = store.getState().auth;
    const refreshToken = userData?.refresh ? userData?.refresh : null;
    if (refreshToken) {
      const url = ApiRoutes.refreshToken;
      const { data } = await API.post(url, { refresh: refreshToken });
      if (data?.access) {
        dispatch(updateUserTokens(data));
      }
      return Promise.resolve(data?.access);
    }
    throw 'Something goes wrong';
  } catch (e) {
    dispatch(clearUserData());
  }
};

export const logoutRequest = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const { userData } = store.getState().auth;
    const refreshToken = userData?.refresh ? userData?.refresh : null;

    if (refreshToken) {
      const url = ApiRoutes.logout;
      await API.post(url, { refresh: refreshToken });
      return Promise.resolve('User logged out');
    }
    throw 'Something went wrong';
  } catch (e) {
    throw e;
  }
};

export const updateUserPreferencesRequest = async (userId: string | null, ln: string) => {
  const { users, preferences } = ApiRoutes;
  const body = { ln };
  const url = `${users}/${userId}${preferences}`;
  const { data } = await API.put(url, body);
  return data;
};

export const getUserInfo = async () => {
  const url = ApiRoutes.userInfo;
  const { data } = await API.get(url);
  return data;
};

export interface ISsoSettings {
  sso_enabled: boolean;
  tenant_configured: boolean;
  entra_id_tenant: string | null;
}

export const getSsoSettings = async (): Promise<ISsoSettings> => {
  const { data } = await API.get(ApiRoutes.orgSsoSettings);
  return data;
};

export const updateSsoEnabled = async (sso_enabled: boolean): Promise<ISsoSettings> => {
  const { data } = await API.patch(ApiRoutes.orgSsoSettings, { sso_enabled });
  return data;
};

export const validateAndSetTenant = async (tenant_id: string): Promise<ISsoSettings> => {
  const { data } = await API.post(ApiRoutes.orgSsoValidate, { tenant_id });
  return data;
};

export const resetSsoTenant = async (): Promise<ISsoSettings> => {
  const { data } = await API.delete(ApiRoutes.orgSsoSettings);
  return data;
};

export const getSsoAdminConsentUrl = async (): Promise<string> => {
  const { data } = await API.get(ApiRoutes.orgSsoAdminConsentUrl);
  return data.admin_consent_url;
};
export const switchOrganizationRequest = async (organizationId: string, refreshToken: string) => {
  const { login, switchOrganization } = ApiRoutes;
  const url = `${login}${switchOrganization}`;
  const { data } = await API.post(url, { organizationId, refreshToken });
  return data;
};
